import { notification } from '../../../../common/utils';

export const handleHttpError = (error: any) => {
  notification.error({
    description: error?.response?.data?.errors?.[0] || 'Network Error',
    autoClose: false,
  });
};
